<ng-container [ngSwitch]="style">
  <ng-container *ngSwitchDefault>
    <div class="lds-ring {{size}}">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'sun'">
    <div class="lds-hourglass {{size}}">
      <i class="pvsc-icon icon-pvc-sun text-[80px]"></i>
    </div>
  </ng-container>
</ng-container>
